import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RejectionNotice({ items, onAcknowledge, labels }) {
    if (items.length === 0)
        return null;
    return (_jsx("section", { className: "rejections", role: "alert", "aria-label": labels.title, children: items.map((item) => (_jsxs("div", { className: "rejections__item", children: [_jsx("p", { className: "rejections__message", children: item.message }), _jsx("button", { type: "button", onClick: () => onAcknowledge(item.id), children: labels.acknowledge })] }, item.id))) }));
}
//# sourceMappingURL=RejectionNotice.js.map